import {
  ExperienceProductDto,
  ExperienceVariationPriceDto,
  VariationFe,
} from "@intelligems/ig-types";
import { fromGqlId } from "@src/api/formatters/shopify";
import { AgProduct } from "@src/store/slices/agProducts/types";

export const agProductsToExperienceProducts = (
  agProducts: AgProduct[],
  variations: VariationFe[]
): ExperienceProductDto[] => {
  const agProductHashById: AgProductHashById = {};
  const variationMap = new Map(variations.map((v) => [v.id, v]));

  for (const agProduct of agProducts) {
    if (agProduct.productId in agProductHashById) {
      agProductHashById[agProduct.productId].variants.push({
        id: fromGqlId(agProduct.variantId),
        title: agProduct.variantTitle,
        variationPrices: agVariationStateToExpProductVariationState(
          agProduct.variationPrices,
          variationMap
        ),
      });
    } else {
      agProductHashById[agProduct.productId] = {
        id: fromGqlId(agProduct.productId),
        title: agProduct.productTitle,
        image: agProduct.productImage,
        handle: agProduct.handle,
        variants: [
          {
            id: fromGqlId(agProduct.variantId),
            title: agProduct.variantTitle,
            variationPrices: agVariationStateToExpProductVariationState(
              agProduct.variationPrices,
              variationMap
            ),
          },
        ],
      };
    }
  }
  return Object.values(agProductHashById);
};

interface AgProductHashById {
  [key: string]: ExperienceProductDto;
}

const agVariationStateToExpProductVariationState = (
  agVariationPrices: AgProduct["variationPrices"],
  variationMap: Map<string, VariationFe>
): ExperienceVariationPriceDto[] => {
  const variationPrices: ExperienceVariationPriceDto[] = [];
  for (const value of Object.values(agVariationPrices)) {
    variationPrices.push({
      id: value.id,
      uuid: value.uuid,
      price: value.price!,
      variationId: value.variationId,
      compareAtPrice: value.compareAtPrice,
      name: variationMap.get(value.variationId)?.name ?? value.name,
      subscriptionDiscount:
        value.subscriptionDiscount === null ||
        value.subscriptionDiscount === undefined
          ? null
          : parseFloat(value.subscriptionDiscount),
      subscriptionDiscountType: value.subscriptionDiscountType ?? null,
    });
  }
  return variationPrices;
};
